module.exports = __webpack_public_path__ + "static/media/page-break.d4fa910b.svg";